// extracted by mini-css-extract-plugin
export default {"addButton":"style_addButton__CWj3U","mainContainer":"style_mainContainer__1F3k6"};